import { Button, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box, Spacer } from 'native-base';
import React from 'react';

import { useFooter } from '../../hooks';
import { BasketButton } from '../SectionWrapper/button';

interface FooterProps {
  variant?: 'resume' | 'select';
  hasSendButton?: boolean;
  actionButtonTitle?: string;
  handleActionButton?: () => void;
  actionButtonIsDisabled?: boolean;
  handleCancelButton?: () => void;
  cancelButtonIsDisabled?: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  variant = 'select',
  hasSendButton = false,
  actionButtonTitle = 'Continuar',
  handleActionButton,
  actionButtonIsDisabled,
  cancelButtonIsDisabled,
  handleCancelButton,
}) => {
  const {
    handlePressBasketButton,
    continueButtonIsDisabled,
    goToNextStep,
    handleCancelOrder,
    cancelOrderIsDisabled,
    basketCartCount,
    isMobile,
    isDesktop,
  } = useFooter();

  const actionButtonDisabled = actionButtonIsDisabled ?? continueButtonIsDisabled;
  const cancelButtonDisabled = cancelButtonIsDisabled ?? cancelOrderIsDisabled;

  const onPressActionButton = handleActionButton ?? goToNextStep;
  const onPressCancelButton = handleCancelButton ?? handleCancelOrder;

  const variantIsSelect = variant === 'select';

  if (isMobile) {
    return (
      <HStack
        alignItems="center"
        justifyContent="space-between"
        p={Spacing['inline.xxxs']}
        bg="neutral.white">
        {variantIsSelect && (
          <BasketButton count={basketCartCount} onPress={handlePressBasketButton} />
        )}
        <Button
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          w={variantIsSelect ? '1/2' : 'full'}
          isDisabled={actionButtonDisabled}
          variant={hasSendButton ? 'callToAction' : 'primary'}
          onPress={onPressActionButton}>
          {actionButtonTitle}
        </Button>
      </HStack>
    );
  }

  return (
    <Box py={Spacing['inset.sm']} bg={{ base: 'neutral.white', lg: 'transparent' }}>
      <HStack alignItems="center" justifyContent="space-between">
        {isDesktop && <Spacer />}
        <HStack
          space={Spacing['inline.xxxs']}
          {...(!isDesktop && {
            width: 'full',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: Spacing['inline.xxxs'],
          })}>
          <Button
            _text={{ fontWeight: Typography['fontweight.semibold'] }}
            variant="secondary"
            isDisabled={cancelButtonDisabled}
            onPress={onPressCancelButton}>
            Cancelar
          </Button>
          <Button
            _text={{ fontWeight: Typography['fontweight.semibold'] }}
            isDisabled={actionButtonDisabled}
            variant={hasSendButton ? 'callToAction' : 'primary'}
            onPress={onPressActionButton}>
            {actionButtonTitle}
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
};
